import React, { useContext, useRef } from 'react'
import classNames from 'classnames'
import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  PANEL_LAYOUT_TYPES,
  PANEL_TRANSITION_TYPES,
  TEXT_SIZES,
} from '@helpers/constants'
import { AppContext } from '@state/context'
import { useConfirm } from '@hooks/useConfirm'
import Button from '@components/Button'
import Text from '@components/Text'
import Divider from '@components/Divider'
import Heading from '@components/Heading'
import Panel from '@views/Panels/Panel'
import ButtonWithLoader from '@components/ButtonWithLoader'

const ConfirmationDialog = () => {
  const [state] = useContext(AppContext)
  const { onCancel, onConfirm } = useConfirm()
  const { show, title, text, additionalText, confirmText, cancelText } =
    state?.confirmation || {}

  if (!show) return null

  const overlayClasses = classNames('fixed inset-0 z-50 bg-black opacity-40')

  return (
    <>
      <div className={overlayClasses} onClick={onCancel} />

      <Panel
        visible={true}
        transitionType={PANEL_TRANSITION_TYPES.FADE}
        layoutType={PANEL_LAYOUT_TYPES.MODAL}
        width={'calc(100% - 4rem)'}
        shadow
        zIndex={50}
      >
        <div className={'relative'}>
          <div className='absolute top-0 right-0'>
            <Button
              handleClick={onCancel}
              size={BUTTON_SIZE.NO_PADDING}
              icon={'Close'}
            />
          </div>
        </div>

        <div className={'flex flex-col items-center'}>
          {title && <Text>{title}</Text>}

          {text && (
            <div className='text-center max-w-[600px]'>
              <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
                {text}
              </Heading>
            </div>
          )}

          {additionalText && (
            <>
              <Divider size={DIVIDER_SIZE.SMALL} />
              <Text>{additionalText}</Text>
            </>
          )}

          <Divider size={DIVIDER_SIZE.BASE} />

          <ButtonWithLoader
            type={BUTTON_TYPE.PRIMARY}
            disabledText={confirmText}
            enabledText={confirmText}
            handleClick={onConfirm}
          />

          <Divider size={DIVIDER_SIZE.SMALL} />

          <Button
            type={BUTTON_TYPE.ALERT_RED_DARK}
            size={BUTTON_SIZE.LARGE}
            handleClick={onCancel}
          >
            {cancelText}
          </Button>
        </div>
      </Panel>
    </>
  )
}

ConfirmationDialog.propTypes = {}

export default ConfirmationDialog
